export enum CyoPricingLifetimeEnum {
  Day = 1,
  Hour = 2,
  Minutes = 3,
}
